import { useCallback, useContext } from 'react';
import { isJourneyReport } from 'reporting-data/tsTypes/reportTypes';
import { EVENTS } from '../../../../lib/events';
import { STANDARD_FIELD_TYPES } from 'reporting-ui-components/lib/report-strategies/shared/constants/fieldTypes';
import { getStandardFieldType } from 'reporting-ui-components/lib/report-strategies/shared/utils/reportGetters';
import { EnablementTrackingContext } from '../../../../monitoring/EnablementTrackingContext';
export function useAIInsightsTracker(report) {
  const {
    enablementUsageTracker,
    trackingApplicationName,
    trackingScreenName,
    trackingAssetType
  } = useContext(EnablementTrackingContext);
  const trackAIInsightsEvent = useCallback(({
    action
  }) => {
    enablementUsageTracker.track(EVENTS.reportingAIAssistantInsightsInteraction, {
      action,
      assetType: trackingAssetType,
      applicationName: trackingApplicationName,
      whereScreen: trackingScreenName,
      chartType: isJourneyReport(report) ? report.get('chartType') : getStandardFieldType(report, STANDARD_FIELD_TYPES.CHART_TYPE)
    });
  }, [enablementUsageTracker, trackingAssetType, trackingApplicationName, trackingScreenName, report]);
  return {
    trackAIInsightsEvent
  };
}